module.exports = __webpack_public_path__ + "static/2-Tensiones - close up-2bc4bb8b3cf41cdca89a682485e901b7.jpg";